export const INTANGIBLE_LEVEL_OPTIONS = Object.freeze([
    { label: "Extreme", amount: 100000 },
    { label: "Very High", amount: 50000 },
    { label: "High", amount: 25000 },
    { label: "Medium", amount: 10000 },
    { label: "Low", amount: 5000 },
]);

const INTANGIBLE_LEVEL_AMOUNT_MAP = Object.freeze(
    INTANGIBLE_LEVEL_OPTIONS.reduce((acc, { label, amount }) => {
        acc[String(label).trim().toLowerCase()] = amount;
        return acc;
    }, {})
);

export function getIntangibleAnnualAmount(level) {
    if (!level) return 0;
    const key = String(level).trim().toLowerCase();
    return INTANGIBLE_LEVEL_AMOUNT_MAP[key] ?? 0;
}

